import React from 'react';
import FormularioComunidad from '../../components/FormularioComunidad';

const FormularioComunidadPage = () => <FormularioComunidad />;

export default FormularioComunidadPage;
